import _ from "lodash";
import React from "react";
import {
  Announcements3D,
  ProgressSummary3D,
  ReflectiveProject3D,
  Shifu3D,
} from "@toddle-edu/ds-icons";
import { getCloudUrl } from "Constants";

export const AI_MODULES_FOR_MARKETING = {
  LESSON_PLANNING: "LESSON_PLANNING",
  PROGRESS_REPORTS: "PROGRESS_REPORTS",
  PORTFOLIO: "PORTFOLIO",
  ANNOUNCEMENTS: "ANNOUNCEMENTS",
  AI_TUTOR: "AI_TUTOR",
};

export const AI_MODULE_MARKETING_UI_CONFIGURATIONS = {
  LESSON_PLANNING: {
    key: "LESSON_PLANNING",
    variant: "--tag-background-yellow-default",
    textColor: "--text-semantic-warning",
    header: {
      subTitle: "ai:lesson_planning_marketing_subtitle",
      icon: () => (
        <img
          src={`${getCloudUrl()}/assets/ai-marketing/LessonPlanning3D.png`}
          alt="Lesson Planning"
          style={{ width: "48px", height: "48px" }}
        />
      ),
    },
    slides: _.map(_.range(1, 7), index => ({
      title: `ai:lesson_planning_marketing_slide_${index}_title`,
      imageUrl: `${getCloudUrl()}/assets/ai-marketing/ai-marketing-lesson-planning-slide-${index}.png`,
    })),
  },
  PROGRESS_REPORTS: {
    key: "PROGRESS_REPORT",
    variant: "--tag-background-teal-default",
    textColor: "--text-semantic-info",
    header: {
      subTitle: "ai:progress_reports_marketing_subtitle",
      icon: ProgressSummary3D,
    },
    slides: _.map(_.range(1, 6), index => ({
      title: `ai:progress_reports_marketing_slide_${index}_title`,
      imageUrl: `${getCloudUrl()}/assets/ai-marketing/ai-marketing-progress-reports-slide-${index}.png`,
      ...(index === 3
        ? {
            imageStyles: { marginBottom: "16px" },
          }
        : {}),
    })),
  },
  PORTFOLIO: {
    key: "PORTFOLIO",
    variant: "--tag-background-violet-default",
    textColor: "--text-semantic-info",
    header: {
      subTitle: "ai:portfolio_marketing_subtitle",
      icon: ReflectiveProject3D,
    },
    slides: _.map(_.range(1, 4), index => ({
      title: `ai:portfolio_marketing_slide_${index}_title`,
      imageUrl: `${getCloudUrl()}/assets/ai-marketing/ai-marketing-portfolio-slide-${index}.png`,
    })),
  },
  ANNOUNCEMENTS: {
    key: "ANNOUNCEMENTS",
    variant: "--tag-background-pink-default",
    textColor: "--text-semantic-error",
    header: {
      subTitle: "ai:announcements_marketing_subtitle",
      icon: Announcements3D,
    },
    slides: _.map(_.range(1, 5), index => ({
      title: `ai:announcements_marketing_slide_${index}_title`,
      imageUrl: `${getCloudUrl()}/assets/ai-marketing/ai-marketing-announcements-slide-${index}.png`,
    })),
  },
  AI_TUTOR: {
    key: "AI_TUTOR",
    variant: "--surface-secondary-selected",
    textColor: "--text-semantic-info",
    header: {
      subTitle: "ai:ai_tutor_marketing_subtitle",
      icon: Shifu3D,
    },
    slides: _.map(_.range(1, 6), index => ({
      title: `ai:ai_tutor_marketing_slide_${index}_title`,
      imageUrl: `${getCloudUrl()}/assets/ai-marketing/ai-marketing-ai-tutor-slide-${index}.png`,
    })),
  },
};

export const AI_MAKERTING_EVENTS = {
  CLICK_AI_BUTTON: "[AI-MARKETING] Clicked AI button",
  UPGRADE_NOW_CLICK: "[AI-MARKETING] Clicked Upgrade Now",
  CHAT_WITH_US_CLICK: "[AI-MARKETING] Clicked Chat with us",
  MEETING_BOOKED: "[AI-MARKETING] Meeting booked",
  AI_TUTOR_EXPLORE_MORE_CLICKED:
    "[AI-MARKETING] Clicked Explore More of AI Tutor banner",
  AI_TUTOR_BOOK_DEMO_CLICKED:
    "[AI-MARKETING]Clicked Book Demo of AI Tutor banner",
  HOMEPAGE_MARKETING_BANNER_CLICKED:
    "[AI-MARKETING] Clicked homepage AI Marketing Banner",
};

export const CHANNEL_MESSAGE_TYPE = {
  AI_MARKETING_UPGRADE_NOW: "AI_MARKETING_UPGRADE_NOW",
  AI_MARKETING_CHAT_WITH_US: "AI_MARKETING_CHAT_WITH_US",
  AI_MARKETING_MEETING_SCHEDULED: "AI_MARKETING_MEETING_SCHEDULED",
};
